import React, { useEffect, useState } from 'react';
import { XCircleIcon } from '@heroicons/react/24/outline';

import useAsync from '../../../../../hooks/useAsync';
import useAxios from '../../../../../hooks/useAxios';

import DataTable from '../../../../../components/DataTable';
import { TemplateReactSelect } from '../../../../../components/Attributes/Attributes_old';

import { getAssets } from '../../../../../api';
import { updateIntegration } from '../../../../../api/company';

const Devices = ({ integration, onRefresh: onRefreshIntegration }) => {
	const apiUrl = `${integration?.apiUrl}/device/v2/getDevices`;
	const [mapping, setMapping] = useState({});

	const { value: devices, execute: onCallEndpoint } = useAxios();
	const { value: assets } = useAsync(getAssets, {
		defaultPayload: { pageSize: null },
	});
	const {
		//value: updatedConfig,
		execute: onUpdateIntegration,
		status: isUpdatingIntegration,
	} = useAsync(updateIntegration, { immediate: false, defaultPayload: {} });

	const API_KEY = integration?.apiKey;
	const configuration = integration?.configuration?.deviceMapping;

	useEffect(() => {
		if (configuration) {
			setMapping(configuration);
		}
	}, configuration);

	useEffect(() => {
		if (API_KEY) {
			onCallEndpoint(apiUrl, {
				method: 'GET',
				headers: {
					'x-api-key': API_KEY,
				},
			});
		}
	}, [API_KEY]);

	const options = assets?.rows?.map((asset) => ({
		label: `${asset?.manufacturer?.name} ${asset?.model?.name} S/N: ${asset?.serialNumber}`,
		value: asset?.id,
	}));

	return (
		<div className="mt-10">
			<h3>Mapping</h3>

			<DataTable
				data={{ rows: devices?.data || [] }}
				columns={[
					{
						header: 'ID',
						accessorKey: 'deviceId',
						cell: (info) => info?.getValue() || null,
					},
					{
						header: 'NAME',
						accessorKey: 'deviceName',
						cell: (info) => info?.getValue() || null,
					},
					{
						header: 'STATUS',
						accessorKey: 'deviceStatus',
						cell: (info) => info?.getValue() || null,
					},
					{
						header: 'GATEWAY',
						accessorKey: 'gatewayId',
						cell: (info) =>
							`${info?.row?.original?.gatewayName} - ${
								info?.getValue() || null
							}`,
					},
					{
						header: 'LOCATION',
						accessorKey: 'locationName',
						cell: (info) => info?.getValue() || null,
					},
					{
						header: 'MAPPING',
						accessorKey: '',
						cell: (info) => {
							const deviceId = info?.row?.original?.deviceId;

							// asset id
							const value = (Object.keys(mapping || {}) || []).find(
								(key) => mapping[key] === deviceId
							);

							return (
								<div className="col-span-2 flex  items-center">
									<div className="flex-1">
										{' '}
										<TemplateReactSelect
											className="w-64 mt-0"
											options={options}
											onChange={(index, asset) => {
												const selectedAssetId = asset?.value;

												onUpdateIntegration(
													{
														id: integration?.id,
														deviceMapping: {
															...mapping,
															[selectedAssetId]: deviceId,
														},
													},
													() =>
														setMapping({
															...mapping,
															[selectedAssetId]: deviceId,
														})
												);

												/*
												{label: 'Liconic STX220 S/N: asf23', value: '3ef92dd2-087a-4d9f-9d5a-c86852204311'}
												*/
												/*onUpdateIntegration(
													{
														id: integration?.id,
														deviceMapping: {
															...configuration,
															[assetId?.value]: info?.row?.original?.deviceId,
														},
													}
													//() => onRefreshIntegration()
												);*/
											}}
											skip={Object.keys(mapping || {}) || []}
											disabled={isUpdatingIntegration === 'pending'}
											value={options?.find((o) => o.value === value)}
										/>
									</div>
									{value ? (
										<div className="flex-shrink flex items-center ml-3">
											<XCircleIcon
												className="w-6 h-6 cursor-pointer text-gray-500"
												onClick={() => {
													let updatedMapping = { ...mapping };
													delete updatedMapping[value];

													onUpdateIntegration(
														{
															id: integration?.id,
															deviceMapping: updatedMapping,
														},
														() => setMapping(updatedMapping)
													);
												}}
											/>
										</div>
									) : null}
								</div>
							);
						},
					},
				]}
				useExport={false}
				usePagination={false}
				hasCheckboxes={false}
				manualSorting={false}
			/>
		</div>
	);
};

export default Devices;
